import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-guarantor',
  templateUrl: './guarantor.component.html'
})
export class GuarantorComponent implements OnInit {

  @Output()
  formReady = new EventEmitter<FormGroup>();

  @Input() editGarantizador: any;

  showGarantizador = false;
  public form: FormGroup;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      name: ['', [Validators.required]],
      ss: ['', [Validators.required]],
      licence: ['', [Validators.required]],
      birthDate: ['', [Validators.required]],
      civilStatus: ['', [Validators.required]],
      dependientes: ['', [Validators.required]],
      spouseName: ['', [Validators.required]],
      spousePhone: ['', [Validators.required]],
      pariente: ['', [Validators.required]],
    });
    this.formReady.emit(this.form);
    if(this.editGarantizador){
      this.form.patchValue(this.editGarantizador);
      if(this.editGarantizador.name.length > 2 ){
        let radioBtn:any = document.querySelector('#hasGuaranterSi');
        radioBtn.checked = true;
        this.showGarantizador = true;
      } else{
        let radioBtn:any = document.querySelector('#hasGuaranterNo');
        radioBtn.checked = true;
        this.showGarantizador = false;
      }
    }
  }

  garantizador(value:any){
    if(value.target.value== "si"){
      this.showGarantizador = true;
    }else{
      this.showGarantizador = false;
    }
  }

  addChildForm(name: string, group: FormGroup) {
    this.form.addControl(name, group);
  }

}
